import { createTheme, responsiveFontSizes } from "@mui/material";
// import { deepmerge } from "@mui/utils";
import typography from "./typography";
import palette from "./palette";

const globalTheme = ({ fontSizeScale = 3 }) => {
  let theme = createTheme({
    typography: typography(fontSizeScale),
    palette: palette(),
    spacing: 8,
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 900,
        lg: 1200,
        xl: 1600,
      },
    },
    components: {
      MuiGrid: {
        styleOverrides: {
          root: {
            "&.AI_main_left": {
              // height: "auto",
            },
            "& ::-webkit-scrollbar": {
              borderRadius: "8px",
              width: "8px",
              backgroundColor: "#FAFAFA",
            },
            "& ::-webkit-scrollbar-thumb": {
              borderRadius: "8px",
              backgroundColor: "#BDBDBD",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "&.AI_input": {
              overflowY: "hidden",
              "& .MuiInputBase-root": {
                height: "100%",
                display: "flex",
                alignItems: "start",
                "& .MuiInputBase-inputMultiline": {
                  maxHeight: "100%",
                },
              },
            },
          },
        },
      },
    },
  });
  // If needed to merge 2 theme, use deepmerge
  // const theme = createTheme(deepmerge(options1, options2));
  theme = responsiveFontSizes(theme);
  return theme;
};

export default globalTheme;
